import {
  Stack,
  Typography,
  Button,
  Divider,
  TableRow,
  TableCell,
  Box,
  Avatar,
} from '@mui/material';
import { FC, useState } from 'react';
import CompanyUnassignModal from './CompanyUnassignModal';
import { Company } from '@staffedupusa/shared-components';
import {
  lightGrey2,
  primaryGreen,
  primaryGrey,
  primaryRed,
  white,
  yellow,
} from '@styles/colors';
import { PLANS } from '@utils/pricing';

type CompanyRowProps = {
  item: Company;
  templateName: string;
};

const CompanyRow: FC<CompanyRowProps> = ({ item, templateName }) => {
  const [showUnassignModal, setShowUnassignModal] = useState(false);

  const getLabel = (company: Company) => {
    switch (company.plan) {
      case 0:
        return 'Expired';
      case 999:
        return 'Trial';
      case 1:
      case 2:
      case 4:
        return 'Paid';
      case 3:
        return 'Paid';
      default:
        return '-';
    }
  };

  const getBackgroundColor = (company: Company) => {
    switch (company?.plan) {
      case 0:
        return primaryRed;
      case 999:
        return yellow;
      case 1:
      case 2:
      case 4:
        return primaryGreen;
      default:
        return primaryGrey;
    }
  };
  const getPlanDetail = (plan: number) => {
    switch (plan) {
      case 0:
        return PLANS.EXPIRED.NAME;
      case 1:
        return PLANS.SMARTER.NAME;
      case 2:
        return PLANS.PRO.NAME;
      case 4:
        return PLANS.STARTER.NAME;
      case 999:
        return PLANS.TRIAL.NAME;
      default:
        return '-';
    }
  };
  return (
    <>
      <TableRow>
        <TableCell>
          {' '}
          <Stack direction="row" alignItems="center">
            <Avatar
              src={(item.s_logo_file as string) || ''}
              style={{
                width: '50px',
                height: '50px',
                marginRight: '12px',
                borderRadius: 5,
              }}
            />
            <Box>
              {item.s_name || '-'}
              <Typography
                textTransform="capitalize"
                variant="subtitle2"
                color={lightGrey2}
                gutterBottom
              >
                Plan: <b>{getPlanDetail(item.plan)}</b>
              </Typography>
            </Box>
          </Stack>
        </TableCell>
        <TableCell>{item.s_email || '-'}</TableCell>
        <TableCell>
          <Box
            sx={{
              backgroundColor: getBackgroundColor(item),
              color: white,
              padding: 0.5,
              textAlign: 'center',
              borderRadius: 5,
            }}
          >
            {getLabel(item)}
          </Box>
        </TableCell>
        <TableCell>
          <Button
            variant="contained"
            color="error"
            size="small"
            onClick={() => setShowUnassignModal(true)}
          >
            Unassign
          </Button>
        </TableCell>
      </TableRow>
      {showUnassignModal && (
        <CompanyUnassignModal
          handleClose={() => setShowUnassignModal(false)}
          company={item}
          templateName={templateName}
        />
      )}
    </>
  );
};

export default CompanyRow;
